import Button from '../../../../../../components/buttons/Button';
import React from 'react';
import { isEmpty } from 'lodash';
import { deleteLabel } from '../../../../../../../common/labels/labelActions';
import { useDispatch } from 'react-redux';
import { LabeledElementsData } from '../../../../../../../common/api/labels/labelElementsRetrievalRouteTypes';
import { Label } from '../../../../../../../common/labels/labelTypes';

type Props = {
    label: Label | null;
    labeledElements: LabeledElementsData[] | null;
    translate: (key: string, options?: Record<string, any>) => string;
};

const LabelDeleteButton = (props: Props) => {
    const { label, labeledElements, translate } = props;

    const dispatch = useDispatch();

    const elementCount = isEmpty(labeledElements) || !labeledElements ? 0 : labeledElements.length;

    const deleteLabelHandler = () => {
        if (!label) return;
        dispatch(deleteLabel(label.id));
    };

    return (
        <Button className="flex w-48 !mx-6 !py-1 !px-4 hover:!bg-gray-100" onClick={deleteLabelHandler}>
            <div className="flex w-full items-center justify-between gap-4">
                <span>{translate('delete')}</span>
                {elementCount > 0 && (
                    <span className="text-xs text-gray-400">{translate('used', { count: elementCount })}</span>
                )}
            </div>
        </Button>
    );
};

export default LabelDeleteButton;
